/*
    node_js
    3/5/2021 7:07 PM
    by Oleksandr
*/
import '../../CWP.css'
import React from "react";
import {calcApproach, calcFlight} from "../../../../calc/calc";

const CallsignMenu = (props) => {
    const {
        callsignMenuFlight, assumeFlight, conAssumeFlight, isCon, isPlt,
        tickValue, showCallsignMenu, runways
    } = props;
    let index = isCon ? 0 : tickValue + callsignMenuFlight.flight.timeShift;
    return (
        <>
            <div className={'callsignMenu'}
                 style={{left: callsignMenuFlight.clientX + 'px', top: callsignMenuFlight.clientY + 'px'}}>
                {callsignMenuFlight.flight.c}
                <span className={'buttonSDD'} onClick={() => {
                    if (isPlt) assumeFlight(callsignMenuFlight.flight, index);

                    if (isCon) conAssumeFlight(callsignMenuFlight.flight);
                        showCallsignMenu(null);
                }}>
                    {((isPlt && callsignMenuFlight.flight.flight[index].isAdvanced) ||
                        (isCon && callsignMenuFlight.flight.isAdvanced))
                        && 'Assume'}
                    {((isPlt && callsignMenuFlight.flight.flight[index].isAssumed) ||
                        (isCon && callsignMenuFlight.flight.isAssumed))
                        && 'Decontrol'}
                    {((isPlt && !callsignMenuFlight.flight.flight[index].isAdvanced &&
                        !callsignMenuFlight.flight.flight[index].isAssumed) ||
                        (isCon && !callsignMenuFlight.flight.isAdvanced &&
                            !callsignMenuFlight.flight.isAssumed))
                        && 'Force Assume'}
                </span>

                {(isPlt && callsignMenuFlight.flight.ades !== "UKLL") &&
                <>
                <span className={'buttonSDD'} onClick={() => {
                    callsignMenuFlight.flight.ades = 'UKLL';
                    callsignMenuFlight.flight.fpl[10].push({
                        isAdes: true,
                        latitude: 49.809722,
                        longitude: 23.958333,
                        name: 'UKLL'
                    });
                    callsignMenuFlight.flight.flight[index].nP = callsignMenuFlight.flight.fpl[10].length - 1;
                    calcApproach(callsignMenuFlight.flight, runways);
                    calcFlight(callsignMenuFlight.flight, index);
                    showCallsignMenu(null);
                }}>
                    Divert to UKLL
                </span>
                </>
                }
                {(callsignMenuFlight.flight.flight[index].isIAA && !callsignMenuFlight.flight.flight[index].isGA) &&
                <span className={'buttonSDD'} onClick={() => {
                    callsignMenuFlight.flight.flight[index].isGA = true;
                    calcApproach(callsignMenuFlight.flight, runways);
                    calcFlight(callsignMenuFlight.flight, index);
                    showCallsignMenu(null);
                }}>
                    Go Around
                    </span>}
                <span className={'buttonSDD'} onClick={() => {
                    showCallsignMenu(null);
                }}>Close</span>
            </div>
        </>
    );
}

export default CallsignMenu;